var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"s-header-mobile__tip-button",attrs:{"aria-hidden":_vm.hidden,"href":_vm.link.uri}},[_c('span',{staticClass:"s-header-mobile__tip-button__label"},[_vm._v(_vm._s(_vm.link.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }